import { CardMedia } from '@mui/material';

const LogoName = 'nivesh.png';

const logoWidth = '145px';

export const Logo1 = (): JSX.Element => {
  return (
    <CardMedia
      component="img"
      src={`/images/${LogoName}`}
      alt="Niveshaay Logo"
      sx={{ width: logoWidth, mt: 1, ml: 2, pb: 1 }}
    />
  );
};

export const LogoEditApplication = (): JSX.Element => {
  return (
    <CardMedia
      component="img"
      src={`/images/${LogoName}`}
      alt="Niveshaay Logo"
      sx={{ width: logoWidth, m: 2, my: 0.5 }}
    />
  );
};

export const LogoSideBar = (): JSX.Element => {
  return (
    <CardMedia
      component="img"
      src={`/images/${LogoName}`}
      alt="Niveshaay Logo"
      sx={{ width: logoWidth }}
    />
  );
};
